import { useApiQuery } from "./use-api-query.ts";

export function useShardTotals() {
  return useApiQuery<number[]>("/suite-runs/shards", {
    staleTime: 60 * 1000, // Cache for 1 minute
  });
}
